import { render, staticRenderFns } from "./ArticleCategoryAdd.vue?vue&type=template&id=0db5f42f"
import script from "./ArticleCategoryAdd.vue?vue&type=script&lang=js"
export * from "./ArticleCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports